// pages/NotFound.jsx
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-[900px] sm:min-h-[800px] bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Icono o Imagen */}
        <div className="mb-8">
          <div className="w-32 h-32 mx-auto bg-[#5cba3c] rounded-full flex items-center justify-center">
            <svg
              className="w-16 h-16 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 20c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8c0 1.703-.528 3.281-1.43 4.577"
              />
            </svg>
          </div>
        </div>

        {/* Texto Principal */}
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Página No Encontrada
        </h2>

        <p className="text-gray-600 mb-8 text-lg">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>

        {/* Botón de Regreso */}
        <Link
          to="/"
          className="inline-flex items-center px-8 py-4 bg-[#5cba3c] text-white font-semibold rounded-lg hover:bg-[#47bb21] transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
        >
          <svg
            className="w-5 h-5 mr-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            />
          </svg>
          Volver al Inicio
        </Link>

        {/* Información adicional */}
        <div className="mt-12 p-6 bg-white rounded-lg shadow-md border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            ¿Buscas algo específico?
          </h3>
          <p className="text-gray-600 mb-4">
            Explora nuestras categorías principales:
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/category/empaque-y-logistica"
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-[#5cba3c] hover:text-white transition-colors duration-200 text-sm"
            >
              Empaque
            </Link>
            <Link
              to="/category/suministros-institucionales"
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-[#5cba3c] hover:text-white transition-colors duration-200 text-sm"
            >
              Suministros
            </Link>
            <Link
              to="/category/glosario-y-formacion"
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-[#5cba3c] hover:text-white transition-colors duration-200 text-sm"
            >
              Glosario
            </Link>
          </div>
        </div>

        {/* Enlace de contacto */}
        <div className="mt-6">
          <p className="text-gray-500 text-sm">
            ¿Necesitas ayuda?{' '}
            <a
              href="https://packsys.com/pages/contacto"
              target="_blank"
              className="text-[#5cba3c] hover:text-[#47bb21] font-medium transition-colors duration-200"
            >
              Contáctanos
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
